module.exports = __webpack_public_path__ + "img/chess-rook-piece.74cb5962.svg";